import gsap from 'gsap'

document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('.video')

  if (videos) {
    videos.forEach(videoBlock => {
      const sound = videoBlock.querySelector('.video-sound input')
      const video = videoBlock.querySelector('.video__wrapper video')
      const controllPlay = videoBlock.querySelector('.video__play')
      const fullScreen = videoBlock.querySelector('.video__fullscreen')
      const progressbar = videoBlock.querySelector('.video__progressbar span')
      let timeLine = gsap.timeline()

      const videoStart = () => {
        if (video.classList.contains('video--lazy')) {
          video.play()
        }

        let time = video.currentTime
        const fullTime = video.duration
        timeLine.to(progressbar, { width: `100%`, delay: 0, duration: fullTime - time, ease: 'none' })
      }

      sound.addEventListener('change', () => {
        video.muted = !sound.checked
      })
      sound.dispatchEvent(new Event('change'))

      const startProgressbar = () => videoStart()
      const stopProgressbar = () => {
        timeLine.pause()
        timeLine = gsap.timeline()
      }

      const stopAndPlay = (e) => {
        e.stopPropagation()
        if (video.paused) {
          videoBlock.classList.add('video--view')
          video.play()
          startProgressbar()
          return
        }
        stopProgressbar()
        video.pause()
      }
      const fullScreenOpen = (element) => {
        element.requestFullscreen();
        videoBlock.classList.add('video--open')
      }

      const fullScreenCancel = (key = null) => {
        if (key) document.exitFullscreen();
        videoBlock.classList.remove('video--open')
      }

      document.addEventListener('fullscreenchange', () => {
        if (window.innerHeight !== screen.height) {
          fullScreenCancel()
        }
      });
      fullScreen.addEventListener('click', (e) => {
        e.stopPropagation()
        if (videoBlock.classList.contains('video--open')) {
          fullScreenCancel(true)
          return
        }
        fullScreenOpen(videoBlock)
      })


      controllPlay.addEventListener('click', stopAndPlay)

      videoBlock.addEventListener('click', stopAndPlay)

    })
  }
})